import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, forkJoin, from, map, of, switchMap } from 'rxjs';

import { DataRepository } from '@core/data/data-repository';
import { SetupApiActions, SetupPageActions } from './setup.actions';

/** Loads the authored Get Started checklist. */
@Injectable()
export class SetupEffects {
  private readonly actions$ = inject(Actions);
  private readonly repo = inject(DataRepository);

  readonly load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetupPageActions.entered),
      switchMap(() =>
        forkJoin({
          steps: from(this.repo.listSetupSteps()),
          phases: from(this.repo.listSetupPhases()),
        }).pipe(
          map(({ steps, phases }) => SetupApiActions.loadSuccess({ steps, phases })),
          catchError((err: unknown) =>
            of(SetupApiActions.loadFailure({ error: err instanceof Error ? err.message : 'Unknown error' })),
          ),
        ),
      ),
    ),
  );
}
